/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
import { AnchorButton, Intent } from "@blueprintjs/core";
var ReactExampleTagRenderer = /** @class */ (function () {
    function ReactExampleTagRenderer(examples) {
        var _this = this;
        this.examples = examples;
        /**
         * Given the name of an example component, like `"AlertExample"`, attempts to resolve
         * it to an actual example component exported by one of the packages. Also returns
         * the URL of the source code on GitHub.
         */
        this.render = function (_a) {
            var exampleName = _a.value;
            if (exampleName == null) {
                return null;
            }
            var example = _this.examples[exampleName];
            if (example == null) {
                throw new Error("Unknown @example component: " + exampleName);
            }
            return (React.createElement(React.Fragment, null,
                example.render({ id: exampleName }),
                React.createElement(AnchorButton, { className: "docs-example-view-source", fill: true, href: example.sourceUrl, icon: "code", intent: Intent.PRIMARY, minimal: true, target: "_blank", text: "View source on GitHub" })));
        };
    }
    return ReactExampleTagRenderer;
}());
export { ReactExampleTagRenderer };
//# sourceMappingURL=reactExample.js.map